import React from 'react';
import { translate } from '../Services/translation';
import { dataLayerRemoveFromCart } from '../Services/Gtm.service';

const getProduct = (row, updateOrderRowQuantity, removeOrderRow) => {

    return <div className="item-info" data-article-number={row.articleNumber} key={row.rowSystemId}>
        <div className="image"><img src={row.image} alt={row.name} /></div>
        <div className="info">
            <h3>{row.name}</h3>
            <span>{row.deliveryStatusText}</span>
            <div className="price">{row.totalPrice}</div>
            <div className="edit">
                <div className="plus-minus">
                    <button className="quantity minus" onClick={() => updateOrderRowQuantity(row.rowSystemId, row.quantity - 1)}>-</button>
                    <div className="total">{row.quantityString}</div>
                    <button className="quantity plus" onClick={() => updateOrderRowQuantity(row.rowSystemId, row.quantity + 1)}>+</button>
                </div>
                <div className="delete">
                    <a href="#" onClick={() => removeOrderRow(row.rowSystemId)}>{translate('minicart.remove')}</a> {/* Ta bort */}
                    
                    <button className="cart__product-row__remove-button" onClick={() => removeOrderRow(row.rowSystemId)}></button>
                </div>
            </div>
        </div>
    </div>
}

const MiniCart = ({ quantity, orderTotal, checkoutUrl, showInfo, toggle, updateOrderRowQuantity, removeOrderRow, orderRows }) => (
    <div className="cart cart--mini">
        <div className="icon" onClick={() => toggle()}>
            <img src="/ui/images/shopping_bag-24px.svg" alt="" class="b2c" />
            <img src="/ui/images/shopping_bag-24px_w.svg" alt="" class="b2b" />
        </div>
        <div className="bullet" onClick={() => toggle()}>{quantity}</div>
        <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
            <div className="varukorg">
                {translate('minicart.cart')} {/* Varukorg */}
            </div>
            <span className="cart__close-button" onClick={() => toggle()}>
            </span>
            <div>
                <br />
                <div className="cart__product-row">
                    {orderRows.map(row => {
                        const removeOrderRowWithTracking = (rowId) => {
                            try {
                                dataLayerRemoveFromCart([row.gtmEcommerceItem]);
                            } catch (e) {
                                console.log(e);
                            }
                            removeOrderRow(rowId);
                        }

                        return getProduct(row, updateOrderRowQuantity, removeOrderRowWithTracking);
                    })}
                </div>
            </div>
            <div className="cart__summary">
                <div className="total-sum">
                    {translate('minicart.sum')} {orderTotal} {/* Summa: */}
                     
                </div>
            </div>
            <a href={checkoutUrl} className="cart__checkout-button">{translate('minicart.checkout')}</a>
            <span className="cart__checkout-button black" onClick={() => toggle()}>{translate('minicart.continueshopping')}</span> {/* Fortsätt handla */}
            
        </div>
    </div>
)

export default MiniCart;